(function() {
  'use strict';

  var QTY_INPUT_SELECTOR   = 'form.product-purchase-form input[name="quantity"]';
  var SP_INPUT_SELECTOR    = 'form.product-purchase-form input[name="selling_plan"]';
  var ATC_BUTTON_SELECTOR  = 'form.product-purchase-form button[name="add"]';
  var FREQ_SELECT_SELECTOR = 'select[name="stayai_selling_plan"]';

  function init() {
    var product = readProductJson();
    document.querySelectorAll('[data-lxb-selector]').forEach(function(selectorEl) {
      var ctx = {
        selectorEl: selectorEl,
        productPrice: parseInt(selectorEl.getAttribute('data-product-price'), 10) || 0,
        subDiscountPct: parseFloat(selectorEl.getAttribute('data-sub-discount-pct')) || 0,
        boxSize: parseInt(selectorEl.getAttribute('data-box-size'), 10) || 6,
        plans: buildPlanMap(product)
      };

      // Qty card click → mark selected, sync the form's quantity input, repaint.
      selectorEl.addEventListener('click', function(e) {
        var card = e.target.closest('[data-lxb-card="qty"]');
        if (!card || !selectorEl.contains(card)) return;
        e.preventDefault();
        selectQty(selectorEl, card);
        applyAll(ctx);
      });

      // One-time/subscription toggle or frequency change → repaint.
      document.addEventListener('change', function(e) {
        if (!e.target) return;
        if (e.target.name === 'selling_plan' ||
            e.target.name === 'purchaseType' ||
            e.target.name === 'stayai_selling_plan') {
          applyAll(ctx);
        }
      });

      // Re-assert the correct selling_plan at submit time. Defends against the
      // Stay AI widget writing its own (6-pack) plan into the hidden input after
      // our last paint — capture phase runs before the theme's serialize().
      var form = document.querySelector('form.product-purchase-form');
      if (form) {
        form.addEventListener('submit', function() { syncSellingPlan(ctx); }, true);
      }

      // Initial paint.
      applyAll(ctx);
    });
  }

  function readProductJson() {
    var el = document.querySelector('[id^="cc-product-json-"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Build a lookup of subscription selling plans keyed by pack size.
  // Stay AI names its bundle groups "Bundle 4 - 24pk" etc.; the base
  // (single-box) group is "Subscribe & Save" with no "Npk" in the name.
  // Returns { byPack: { 24: [plan, ...] }, base: [plan, ...] }
  // where each plan is { id, pct, every2 }.
  function buildPlanMap(product) {
    var map = { byPack: {}, base: null };
    if (!product || !product.selling_plan_groups) return map;
    product.selling_plan_groups.forEach(function(group) {
      var plans = (group.selling_plans || []).map(function(p) {
        var pct = null;
        var adj = p.price_adjustments && p.price_adjustments[0];
        if (adj && adj.value_type === 'percentage') pct = parseFloat(adj.value);
        return { id: String(p.id), pct: pct, every2: isEvery2(p.name) };
      });
      if (!plans.length) return;
      var m = /(\d+)\s*pk/i.exec(group.name || '');
      if (m) {
        map.byPack[parseInt(m[1], 10)] = plans;
      } else if (!map.base) {
        map.base = plans;
      }
    });
    return map;
  }

  function isEvery2(name) {
    return /(\b2\s*month|every\s*2\b|other\s*month)/i.test(name || '');
  }

  function selectQty(selectorEl, card) {
    var qty = parseInt(card.getAttribute('data-qty-value'), 10) || 1;
    selectorEl.querySelectorAll('[data-lxb-card="qty"]').forEach(function(el) {
      var sel = el === card;
      el.classList.toggle('is-selected', sel);
      el.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    syncQty(qty);
  }

  function syncQty(qty) {
    var v = String(qty);
    document.querySelectorAll(QTY_INPUT_SELECTOR).forEach(function(input) {
      if (input.value !== v) input.value = v;
    });
  }

  function currentQty(selectorEl) {
    var card = selectorEl.querySelector('[data-lxb-card="qty"].is-selected');
    if (!card) return 1;
    var n = parseInt(card.getAttribute('data-qty-value'), 10);
    return n > 0 ? n : 1;
  }

  function activeQtyDiscountPct(selectorEl) {
    var card = selectorEl.querySelector('[data-lxb-card="qty"].is-selected');
    if (!card) return 0;
    return parseFloat(card.getAttribute('data-discount-pct')) || 0;
  }

  function isSubscription() {
    var subRadio = document.getElementById('purchaseTypeSubscription');
    if (subRadio) return !!subRadio.checked;
    var hidden = document.querySelector(SP_INPUT_SELECTOR);
    return !!(hidden && hidden.value);
  }

  // true when the shopper picked the "every 2 months" cadence; default monthly.
  function wants2Monthly() {
    var sel = document.querySelector(FREQ_SELECT_SELECTOR);
    if (!sel) return false;
    var opt = sel.options[sel.selectedIndex];
    return opt ? isEvery2(opt.textContent) : false;
  }

  // Guarantee a frequency is chosen (default = first / monthly) and that Stay AI's
  // custom "pretty-select" label reflects it, instead of leaving its transient
  // "Select frequency" placeholder. The hidden selling_plan is set regardless, so
  // a subscription can never be added to cart without a frequency.
  function ensureFrequencyDefault() {
    var sel = document.querySelector(FREQ_SELECT_SELECTOR);
    if (!sel || !sel.options.length) return;
    if (sel.selectedIndex < 0) sel.selectedIndex = 0;
    var opt = sel.options[sel.selectedIndex];
    var pretty = sel.closest('.pretty-select');
    var valueSpan = pretty && pretty.querySelector('span.value');
    if (opt && valueSpan && valueSpan.textContent.trim() !== opt.textContent.trim()) {
      valueSpan.textContent = opt.textContent.trim();
    }
  }

  // The subscription plan matching the current pack size + cadence.
  function planFor(ctx, qty, every2) {
    var packSize = qty * ctx.boxSize;
    var plans = ctx.plans.byPack[packSize] || ctx.plans.base;
    if (!plans || !plans.length) return null;
    var match = plans.filter(function(p) { return p.every2 === every2; })[0];
    return match || plans[0];
  }

  // Writes the correct selling_plan id into the hidden form input (or clears it
  // for one-time). Returns the chosen plan object (or null).
  function syncSellingPlan(ctx) {
    var input = document.querySelector(SP_INPUT_SELECTOR);
    if (!isSubscription()) {
      if (input && input.value !== '') input.value = '';
      return null;
    }
    var plan = planFor(ctx, currentQty(ctx.selectorEl), wants2Monthly());
    var id = plan ? plan.id : '';
    if (input && input.value !== id) input.value = id;
    return plan;
  }

  function applyAll(ctx) {
    var qty = currentQty(ctx.selectorEl);
    var gross = ctx.productPrice * qty;
    var sub = isSubscription();
    if (sub) ensureFrequencyDefault();
    var plan = syncSellingPlan(ctx); // also sets the hidden input

    var price;
    if (sub) {
      // Subscription = flat subscription discount off the gross. The multi-pack
      // (qty) discount NEVER stacks on top — Stay AI's plan already gives 15%.
      var pct = (plan && plan.pct != null) ? plan.pct : ctx.subDiscountPct;
      price = Math.round(gross * (100 - pct) / 100);
    } else {
      // One-time = multi-pack discount from the selected qty card.
      price = Math.round(gross * (100 - activeQtyDiscountPct(ctx.selectorEl)) / 100);
    }

    setAtcButtonPrice(price < gross ? money(gross) : '', money(price));
  }

  // The button's own label ("Add to Cart"), without any price. Derived once from
  // the theme's server-rendered markup and cached, so repeated writes can't
  // compound. Parsing innerHTML on every write was unsafe: the theme renders the
  // price inside a wrapper — `Add to Cart - <span class="theme-money">$28.00</span>`
  // — so a regex hunting for "$" truncated mid-tag, kept the theme's separator
  // dash, and left a dangling <span> the browser silently re-closed.
  function atcBaseLabel(btn) {
    if (btn.dataset.lxbBaseLabel == null) {
      // textContent sidesteps markup entirely: drop everything from the first
      // price onward, then any separator dash left dangling at the end.
      btn.dataset.lxbBaseLabel = btn.textContent
        .replace(/\s+/g, ' ')
        .replace(/\s*\$[\d.,]+[\s\S]*$/, '')
        .replace(/[\s–—-]+$/, '')
        .trim();
    }
    return btn.dataset.lxbBaseLabel;
  }

  function setAtcButtonPrice(grossFormatted, finalFormatted) {
    var btn = document.querySelector(ATC_BUTTON_SELECTOR);
    if (!btn) return;
    var priceHtml = grossFormatted
      ? '<s class="lxb-atc__strike">' + grossFormatted + '</s> ' + finalFormatted
      : finalFormatted;
    var next = atcBaseLabel(btn) + ' - ' + priceHtml;
    if (btn.innerHTML !== next) btn.innerHTML = next;
  }

  // Always two decimals, to match the theme's money_format ("$28.00"). Trimming
  // a trailing ".00" here made the button read "$56" next to the theme's
  // "$28.00" everywhere else on the page.
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
